import type { ProductPerks } from '../components/perk-list';

export type PlaceholderPerkListData = {
  heading: string;
  premiumPerks: ProductPerks;
  proJobsPerks: ProductPerks;
};
// TODO(NW1): Replace these placeholders once its fetched product data is available.
const placeholderPerkListData: Record<'de' | 'en', PlaceholderPerkListData> = {
  de: {
    heading: 'Noch einmal alle Vorteile im Überblick',
    premiumPerks: {
      activationCta: 'Premium freischalten',
      intro:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
      title: 'Premium',
      groups: [
        {
          heading: 'Lorem ipsum dolor sit amet.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
            'Ut enim ad minim veniam, quis nostrud exercitation.',
            'Duis aute irure dolor in reprehenderit.',
          ],
        },
        {
          heading: 'Consectetur adipiscing elit.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
            'Ut enim ad minim veniam, quis nostrud exercitation.',
            'Duis aute irure dolor in reprehenderit.',
            'Excepteur sint occaecat cupidatat non proident.',
            'Sunt in culpa qui officia deserunt mollit anim.',
            'Id est laborum et dolorum fuga.',
          ],
        },
        {
          heading: 'Sed do eiusmod tempor incididunt.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
            'Ut enim ad minim veniam, quis nostrud exercitation.',
            'Duis aute irure dolor in reprehenderit.',
          ],
        },
        {
          heading: 'Ut enim ad minim veniam.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
          ],
        },
        {
          heading: 'Quis nostrud exercitation ullamco.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
          ],
        },
      ],
    },
    proJobsPerks: {
      activationCta: 'ProJobs freischalten',
      intro:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
      title: 'ProJobs',
      groups: [
        {
          heading: 'Lorem ipsum dolor sit amet.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
          ],
        },
        {
          heading: 'Consectetur adipiscing elit.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
            'Ut enim ad minim veniam, quis nostrud exercitation.',
          ],
        },
        {
          heading: 'Sed do eiusmod tempor incididunt.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
          ],
        },
      ],
    },
  },
  en: {
    heading: 'All benefits at a glance',
    premiumPerks: {
      activationCta: 'Unlock Premium',
      intro:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
      title: 'Premium',
      groups: [
        {
          heading: 'Lorem ipsum dolor sit amet.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
            'Ut enim ad minim veniam, quis nostrud exercitation.',
            'Duis aute irure dolor in reprehenderit.',
          ],
        },
        {
          heading: 'Consectetur adipiscing elit.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
            'Ut enim ad minim veniam, quis nostrud exercitation.',
            'Duis aute irure dolor in reprehenderit.',
            'Excepteur sint occaecat cupidatat non proident.',
            'Sunt in culpa qui officia deserunt mollit anim.',
            'Id est laborum et dolorum fuga.',
          ],
        },
        {
          heading: 'Sed do eiusmod tempor incididunt.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
            'Ut enim ad minim veniam, quis nostrud exercitation.',
            'Duis aute irure dolor in reprehenderit.',
          ],
        },
        {
          heading: 'Ut enim ad minim veniam.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
          ],
        },
        {
          heading: 'Quis nostrud exercitation ullamco.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
          ],
        },
      ],
    },
    proJobsPerks: {
      activationCta: 'Unlock ProJobs',
      intro:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
      title: 'ProJobs',
      groups: [
        {
          heading: 'Lorem ipsum dolor sit amet.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
          ],
        },
        {
          heading: 'Consectetur adipiscing elit.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
            'Ut enim ad minim veniam, quis nostrud exercitation.',
          ],
        },
        {
          heading: 'Sed do eiusmod tempor incididunt.',
          perks: [
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            'Sed do eiusmod tempor incididunt ut labore.',
          ],
        },
      ],
    },
  },
};

export const getPlaceholderPerkListData = (
  locale: string
): PlaceholderPerkListData =>
  placeholderPerkListData[locale.startsWith('de') ? 'de' : 'en'];
